import {Expose, Type} from "class-transformer";
import User from "./User";
import Model from "./Model";

export default class Style extends Model implements Likable, Commentable, Imageable {
    name: string;
    description: string;

    @Type(() => User)
    user: User;

    @Expose({name: "user_id"})
    userId: number;

    @Expose({name: "primary_picture_url"})
    primaryPictureUrl: string;

    @Expose({name: "comment_count"})
    commentCount: number;

    //likes
    @Expose({name: "like_count"})
    likeCount: number;

    @Expose({name: "is_liked"})
    isLiked: boolean;

    @Expose({name: "tag_list"})
    tags: string[];
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Style.ts